import React, { useState } from "react";
import PropTypes from "prop-types";

import { Button, Icon } from "semantic-ui-react";

import { useBooleanState } from "hooks";
import DatePickerInput from "components/DatePickerInput";
import MeetingDateTypeDropdown from "components/MeetingDateTypeDropdown";

export const AddEventButton = ({ currentDate, setCurrentDate, addEvent }) => {
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedMeetingDateType, setSelectedMeetingDateType] = useState();
  const [addButtonEnabled, setAddButtonEnabled] = useState(true);
  const [inputDateError, setError, clearError] = useBooleanState();

  const callAddEvent = async (meetingDateTypeId) => {
    setLoading(true);
    await addEvent(meetingDateTypeId);
    setLoading(false);
    setEditing(false);
  };

  return editing ? (
    <div
      style={{
        marginBottom: "1em",
        width: "max-content",
      }}
      data-test="event-field-add-meeting-form"
    >
      <MeetingDateTypeDropdown
        setSelectedMeetingDateType={setSelectedMeetingDateType}
        selectedMeetingDateType={selectedMeetingDateType}
        setIsExistingMeeting={setAddButtonEnabled}
      />
      <DatePickerInput
        defaultDate={currentDate}
        onChange={(d) => {
          if (d) {
            setCurrentDate(d);
            clearError();
          } else {
            setError();
          }
        }}
      />
      <div>
        <Button
          content="Add"
          disabled={loading || !addButtonEnabled || inputDateError}
          loading={loading}
          onClick={() => {
            callAddEvent(selectedMeetingDateType?.id);
          }}
          positive
        />
        <Icon
          color="grey"
          link
          name="delete"
          onClick={() => {
            setEditing(false);
          }}
          size="large"
        />
      </div>
    </div>
  ) : (
    <Button
      basic
      content="Add Meeting"
      onClick={() => {
        setEditing(true);
      }}
      style={{ marginTop: "1em" }}
    />
  );
};

AddEventButton.propTypes = {
  addEvent: PropTypes.func.isRequired,
  currentDate: PropTypes.object.isRequired,
  setCurrentDate: PropTypes.func.isRequired,
};

export default AddEventButton;
